import {combineReducers} from "redux"
import Events from "./MarketingEvents"

const Retrieving = combineReducers({
  Events
})

export default Retrieving
